<!-- Timeline / Editor de Reel -->
<div class="timeline-section card shadow-sm border-0 p-3 mb-4">
  <!-- Header de la tarjeta -->
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <h6 class="mb-0 fw-semibold text-primary d-flex align-items-center">
      <i class="pi pi-list me-1"></i>
      Línea de tiempo del Reel
    </h6>

    <div class="d-flex gap-2">
      <button
        pButton
        type="button"
        label="Guardar"
        icon="pi pi-save"
        class="p-button-sm p-button-primary"
        (click)="saveTimeline()"
      ></button>

      <button
        pButton
        type="button"
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-sm p-button-outlined p-button-danger"
        (click)="cancelTimeline()"
      ></button>
    </div>
  </div>

  <!-- Contenido dividido en 2 columnas -->
  <div class="row g-3">
    <!-- IZQUIERDA: Collage de reels guardados en grid -->
    <div class="col-12 col-md-3">
      <div class="border rounded bg-light p-2 h-100 d-flex flex-column">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="text-muted text-uppercase small fw-bold d-flex align-items-center">
            <i class="pi pi-folder-open me-1 text-primary"></i>
            Reels guardados
          </span>

          <button
            pButton
            type="button"
            icon="pi pi-plus"
            class="p-button-text p-button-rounded p-button-sm"
            title="Nuevo reel"
            (click)="createNewReel()"
          ></button>
        </div>

        <!-- GRID -->
        <div
          class="reels-grid"
          style="
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 0.75rem;
            max-height: 260px;
            overflow-y: auto;
            padding-right: .5rem;
          "
        >
          <div
            class="reel-card card border-0 shadow-sm cursor-pointer"
            *ngFor="let r of reelsDisponibles"
            (click)="selectReel(r)"
            style="transition: all 0.15s ease;"
          >
            <div class="card-body p-2">
              <!-- Mini collage preview 2x2 -->
              <div
                class="rounded overflow-hidden border mb-2"
                style="
                  width: 100%;
                  height: 70px;
                  background-color: #000;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-template-rows: 1fr 1fr;
                  gap: 1px;
                "
              >
                <img
                  *ngFor="let t of r.thumbs | slice:0:4"
                  [src]="t"
                  class="w-100 h-100"
                  style="object-fit: cover;"
                />
              </div>

              <!-- Nombre + cantidad -->
              <div class="d-flex align-items-start justify-content-between">
                <div
                  class="fw-semibold text-truncate"
                  style="font-size: 0.8rem; max-width: 90px;"
                  [title]="r.name"
                >
                  {{ r.name }}
                </div>

                <span
                  class="badge bg-primary text-white ms-2"
                  style="font-size: 0.7rem;"
                >
                  {{ r.items?.length || 0 }}
                </span>
              </div>

              <!-- Descripción corta -->
              <div
                class="text-muted text-truncate"
                style="font-size: 0.7rem; max-width: 100%;"
                [title]="r.descripcion || 'Sin descripción'"
              >
                {{ r.descripcion || 'Sin descripción' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Nota inferior -->
        <div class="mt-2 text-center">
          <small class="text-muted d-block" style="font-size: 0.7rem;">
            Toca un reel para cargarlo en la línea de tiempo.
          </small>
        </div>
      </div>
    </div>

    <!-- DERECHA: Editor / timeline actual -->
    <div class="col-12 col-md-9">
      <div class="timeline-wrapper p-2 bg-light rounded border h-100">
        <div
          class="timeline-dropzone d-flex align-items-start gap-3 flex-nowrap"
          cdkDropList
          #timelineList="cdkDropList"
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="reelTimeline"
          [cdkDropListConnectedTo]="[repertorioList]"
          (cdkDropListDropped)="onDropTimeline($event)"
          style="
            min-height: 140px;
            overflow-x: auto;
            overflow-y: hidden;
            padding-bottom: 0.5rem;
          "
        >
          <div
            class="timeline-item card border-0 shadow-sm p-2 text-center flex-shrink-0"
            *ngFor="let clip of reelTimeline; let i = index"
            cdkDrag
            [cdkDragData]="clip"
            style="min-width: 130px; max-width: 130px;"
          >
            <div class="thumb mb-2">
              <img
                [src]="clip.thumb"
                [alt]="clip.title"
                class="img-fluid rounded"
                style="height: 75px; width: 100%; object-fit: cover;"
              />
            </div>
            <div class="meta small">
              <div class="fw-semibold text-truncate">{{ clip.title }}</div>
              <div class="text-muted">#{{ i + 1 }}</div>
            </div>
          </div>

          <!-- Mensaje cuando está vacío -->
          <div
            *ngIf="!reelTimeline || reelTimeline.length === 0"
            class="text-muted small d-flex flex-column align-items-center justify-content-center text-center p-3"
            style="min-width: 200px;"
          >
            <i class="pi pi-arrow-right-arrow-left mb-2" style="font-size: 1.2rem;"></i>
            Arrastra contenido aquí
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Repertorio -->
<div class="repertorio-section card shadow-sm border-0 p-3">
  <h6 class="mb-3 fw-semibold text-primary d-flex align-items-center">
    <i class="pi pi-video me-1"></i>
    Repertorio disponible
  </h6>

  <div
    class="repertorio-wrapper d-flex flex-wrap gap-3"
    cdkDropList
    #repertorioList="cdkDropList"
    [cdkDropListData]="repertorio"
    [cdkDropListConnectedTo]="[timelineList]"
    (cdkDropListDropped)="onDropRepertorio($event)"
  >
    <div
      class="repertorio-item card p-2 text-center border-0 shadow-sm flex-shrink-0"
      *ngFor="let media of repertorio"
      cdkDrag
      [cdkDragData]="media"
      style="width: 120px;"
    >
      <div class="thumb mb-2">
        <img
          [src]="media.thumb"
          [alt]="media.title"
          class="img-fluid rounded"
          style="height: 75px; width: 100%; object-fit: cover;"
        />
      </div>
      <div class="label small fw-semibold text-truncate">{{ media.title }}</div>
    </div>
  </div>
</div>
